'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTabsOrder, getActiveTabId, getShouldScrollActiveTabIntoView, getIsScrollActiveTabIntoViewRequested } from 'DesignData/selectors/tabs';
import Tabs from 'DesignManagerIde/components/tabs/Tabs';
import * as tabsActions from 'DesignData/actions/Tabs';
import * as ApplicationActions from 'DesignData/actions/Application';
import * as onboardingSelectors from 'DesignData/selectors/onboarding';
import Tab from 'DesignData/js/models/Tab';
import { GETTING_STARTED } from 'DesignData/enums/DesignAssetTypes';
import { getSkipOnboarding } from 'DesignData/selectors/auth';

const makeMapStateToProps = () => {
  const getShouldShowGettingStartedTab = onboardingSelectors.makeGetShouldShowGettingStartedTab();
  return state => {
    return {
      tabsOrder: getTabsOrder(state),
      activeId: getActiveTabId(state),
      shouldScrollActiveTabIntoView: getShouldScrollActiveTabIntoView(state),
      isScrollActiveTabIntoViewRequested: getIsScrollActiveTabIntoViewRequested(state),
      shouldShowGettingStartedTab: getShouldShowGettingStartedTab(state),
      skipOnboarding: getSkipOnboarding(state)
    };
  };
};

const mapDispatchToProps = {
  addPinnedTab: ApplicationActions.addPinnedTab,
  toggleShouldScrollActiveTabIntoView: tabsActions.toggleShouldScrollActiveTabIntoView,
  openTab: tabsActions.openTab
};

class TabsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gettingStartedTabOpened: false
    };
  }

  componentDidMount() {
    this.maybeOpenGettingStartedTab();
  }

  componentDidUpdate() {
    this.maybeOpenGettingStartedTab();
  }

  maybeOpenGettingStartedTab() {
    const {
      addPinnedTab,
      openTab,
      shouldShowGettingStartedTab,
      skipOnboarding
    } = this.props;

    if (shouldShowGettingStartedTab && !skipOnboarding && !this.state.gettingStartedTabOpened) {
      this.setState({
        gettingStartedTabOpened: true
      }, () => {
        openTab(new Tab({
          id: 'gettingStarted',
          assetType: GETTING_STARTED,
          isPinned: true
        }));
        addPinnedTab('gettingStarted');
      });
    }
  }

  render() {
    const {
      tabsOrder,
      openContextMenu,
      activeId,
      shouldScrollActiveTabIntoView,
      toggleShouldScrollActiveTabIntoView,
      isScrollActiveTabIntoViewRequested
    } = this.props;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Tabs, {
        tabsOrder: tabsOrder,
        openContextMenu: openContextMenu,
        activeId: activeId,
        shouldScrollActiveTabIntoView: shouldScrollActiveTabIntoView,
        toggleShouldScrollActiveTabIntoView: toggleShouldScrollActiveTabIntoView,
        isScrollActiveTabIntoViewRequested: isScrollActiveTabIntoViewRequested
      })
    });
  }

}

TabsContainer.propTypes = {
  addPinnedTab: PropTypes.func.isRequired,
  tabsOrder: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  openContextMenu: PropTypes.func.isRequired,
  activeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shouldScrollActiveTabIntoView: PropTypes.bool.isRequired,
  toggleShouldScrollActiveTabIntoView: PropTypes.func.isRequired,
  isScrollActiveTabIntoViewRequested: PropTypes.bool,
  shouldShowGettingStartedTab: PropTypes.bool,
  openTab: PropTypes.func.isRequired,
  skipOnboarding: PropTypes.bool.isRequired
};
TabsContainer.defaultProps = {
  tabsOrder: [],
  activeId: null
};
export default connect(makeMapStateToProps, mapDispatchToProps)(TabsContainer);